export const WorkExperience = [
    {
      title: 'Graphic Design Intern',
      period: '2022-Present',
      desc: 'Currently working as a Graphic Design Intern at PlaySpots, where I create visually engaging designs for marketing materials, social media, and branding campaigns.',
    },
    {
      title: 'Poster Designer for College Events',
      period: 'Present',
      desc: 'Designing creative and impactful posters for various college events, ensuring effective communication and a visually appealing presentation.',
    },
    {
      title: 'Hackathons',
      period: 'Present',
      desc: 'Actively participating in hackathons, contributing through innovative designs and creative solutions to enhance project presentations.',
    },
    {
      title: 'UI/UX Designer for College Projects',
      period: '2022-2023',
      desc: 'Worked on designing user-friendly and aesthetically pleasing interfaces for multiple college projects, focusing on usability and visual appeal.',
    },
    {
      title: 'Creative Lead at IEDC',
      period: '2022-2023',
      desc: 'Served as the Creative Lead for IEDC, overseeing the creative direction and execution of designs for events, campaigns, and promotional materials.',
    },
    {
      title: 'Freelance Photographer',
      period: '2018-Present',
      desc: 'Capturing stunning and memorable moments as a Freelance Photographer, specializing in event photography, portraits, and creative shoots.',
    },
  ];
  